import { render, staticRenderFns } from "./Web_screen.vue?vue&type=template&id=30e065f4&scoped=true&"
import script from "./Web_screen.vue?vue&type=script&lang=js&"
export * from "./Web_screen.vue?vue&type=script&lang=js&"
import style0 from "./Web_screen.vue?vue&type=style&index=0&id=30e065f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e065f4",
  null
  
)

export default component.exports